import React, { useState } from 'react'
import { Box } from '@mui/material'
import { useStyles } from './style'
import UserList from './user-list'
import UserUpload from './user-upload'
import UserDelete from './user-delete'
import PermissionUpload from './user-permission-upload'
import UpdateAttributes from './user-update-attributes'

const COMPONENT_STATE = {
  LIST: 'LIST',
  UPLOAD: 'UPLOAD',
  DELETE: 'DELETE',
  PERMISSION: 'PERMISSION',
  NAMEID: 'NAMEID'
}

const UserTab = () => {
  const classes = useStyles()

  const [componentState, setComponentState] = useState(COMPONENT_STATE.LIST)

  const handleClickUploadUsers = () => {
    if (componentState === COMPONENT_STATE.LIST) {
      setComponentState(COMPONENT_STATE.UPLOAD)
    }
  }

  const handleClickDeleteUsers = () => {
    if (componentState === COMPONENT_STATE.LIST) {
      setComponentState(COMPONENT_STATE.DELETE)
    }
  }

  const handleClickUploadPermissions = () => {
    if (componentState === COMPONENT_STATE.LIST) {
      setComponentState(COMPONENT_STATE.PERMISSION)
    }
  }

  const handleNameIdStart = () => {
    if (componentState === COMPONENT_STATE.LIST) {
      setComponentState(COMPONENT_STATE.NAMEID)
    }
  }

  const handleClickCancel = () => {
    setComponentState(COMPONENT_STATE.LIST)
  }

  const handleUploadStart = () => {
    setComponentState(COMPONENT_STATE.LIST)
  }

  const handleUpdateNameIdStart = () => {
    setComponentState(COMPONENT_STATE.LIST)
  }

  const handleDeleteUsersStart = () => {
    setComponentState(COMPONENT_STATE.LIST)
  }

  const body = () => {
    switch (componentState) {
      case COMPONENT_STATE.UPLOAD:
        return <UserUpload onClickCancel={handleClickCancel} onUploadStart={handleUploadStart} />

      case COMPONENT_STATE.DELETE:
        return <UserDelete onClickCancel={handleClickCancel} onUploadStart={handleDeleteUsersStart} />

      case COMPONENT_STATE.PERMISSION:
        return <PermissionUpload onClickCancel={handleClickCancel} onUploadStart={handleUploadStart} />

      case COMPONENT_STATE.NAMEID:
        return <UpdateAttributes onClickCancel={handleClickCancel} onUploadStart={handleUpdateNameIdStart} />

      default:
        return (
          <UserList
            onClickUploadUsers={handleClickUploadUsers}
            onClickDeleteUsers={handleClickDeleteUsers}
            onClickUploadPermissions={handleClickUploadPermissions}
            onClickNameIdStart={handleNameIdStart}
          />
        )
    }
  }

  return <Box className={classes.container}>{body()}</Box>
}

export default UserTab
